// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

// Use named rather than default exports.
export const AccountNavigationPanel = dynamic(() =>
  import('./AccountNavigationPanel').then(mod => mod.AccountNavigationPanel)
);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AccountNavigationPanelConfig = {
  emptyLabel: 'accountnavigationpanel',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/accountnavigationpanel`,
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AccountNavigationPanelEditable = (props: any) => (
  <EditableComponent config={AccountNavigationPanelConfig} {...props}>
    <AccountNavigationPanel {...props} />
  </EditableComponent>
);
